import React from 'react';

import CollapsibleCardView from '../../../common/CardView/CollapsibleCardView';

import TotalCPUCard from '../../../pipeline_metrics/TotalCPUCard/TotalCPUCard';
import TotalGPUCard from '../../../pipeline_metrics/TotalGPUCard/TotalGPUCard';
import TotalLogStorageCard from '../../../pipeline_metrics/TotalLogStorageCard/TotalLogStorageCard';
import TotalMemoryCard from '../../../pipeline_metrics/TotalMemoryCard/TotalMemoryCard';
import TotalOrchestrationStorageCard
  from '../../../pipeline_metrics/TotalOrchestrationStorageCard/TotalOrchestrationStorageCard';
import TotalModelStorageCard from '../../../pipeline_metrics/TotalModelStorageCard/TotalModelStorageCard';
import AVGCPUCard from '../../../pipeline_metrics/AVGCPUCard/AVGCPUCard';
import AVGMemoryCard from '../../../pipeline_metrics/AVGMemoryCard/AVGMemoryCard';
import AVGGPUCard from '../../../pipeline_metrics/AVGGPUCard/AVGGPUCard';

export type InfrastructureStatsType = {
  totalCpu: {
    current: number,
    max: number,
  },
  totalGpu: {
    current: number,
    max: number,
  },
  totalMem: {
    current: number,
    max: number,
  },
  avgCpu: {
    current: number,
    max: number,
  },
  avgGpu: {
    current: number,
    max: number,
  },
  avgMem: {
    current: number,
    max: number,
  },
  totalOrchStorage: {
    current: number,
    max: number,
  },
  totalModelStorage: {
    current: number,
    max: number,
  },
  totalLogStorage: {
    current: number,
    max: number,
  },
}

type InfrastructureGridPropsType = {
  startTimestamp: number,
  endTimestamp: number,
}

export const InfrastructureConsumptionGrid = ({
  startTimestamp, endTimestamp,
}: InfrastructureGridPropsType) => {
  return (
    // @ts-ignore
    <CollapsibleCardView className="my-4" headerText="Infrastructure Consumption">
      <div className="grid grid-cols-3 gap-x-0 gap-y-1">
        <TotalCPUCard />
        <TotalGPUCard />
        <TotalLogStorageCard />
        <TotalMemoryCard />
        <TotalModelStorageCard />
        <AVGGPUCard startTimestamp={startTimestamp} endTimestamp={endTimestamp} />
        <AVGCPUCard startTimestamp={startTimestamp} endTimestamp={endTimestamp} />
        <AVGMemoryCard startTimestamp={startTimestamp} endTimestamp={endTimestamp} />
      </div>
    </CollapsibleCardView>
  )
}

export default InfrastructureConsumptionGrid;
